<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="EditWorkDraft" :model="formData" :rules="rules" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">

        <el-col :span="24" >
          <el-form-item label="稿件名称">
            <el-input class="input-item" v-model="formData.PaWorkDraft.workName"
              :clearable="true" placeholder="名称" :disabled="true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" >
          <el-form-item label="稿件类型">
            <el-input class="input-item" v-model="formData.PaWorkDraft.workBigTypeName" :clearable="true" :disabled="true"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" >
          <el-form-item label="采用级别" >
            <el-input class="input-item" v-model="formData.PaWorkDraft.workTypeName" :clearable="true" :disabled="true"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" >
          <el-form-item label="员工姓名">
            <el-input class="input-item" v-model="formData.PaWorkDraft.userName" :clearable="true" :disabled="true"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="采用稿件比例">
            <el-select class="input-item" v-model="formData.PaWorkDraft.deptPostName"
                       placeholder="比例" :loading="EditWorkDraft.type.impl.loading"
                       @visible-change="EditWorkDraft.type.impl.onVisibleChange"
                       @change="onTypeValueChange">
              <el-option v-for="item in EditWorkDraft.type.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" >
          <el-form-item label="奖励金额">
            <el-input-number class="input-item" v-model="formData.PaWorkDraft.score" :clearable="true"
                             :disabled="true" placeholder="(元)" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" >
          <el-form-item label="比例评价">
            <el-input class="input-item" v-model="formData.PaWorkDraft.assessDetail" type="textarea" :clearable="true"
                      :autosize="{ minRows: 1,maxRows:3}"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="上传时间">
            <el-input class="input-item" v-model="formData.PaWorkDraft.createTime" :disabled="true"
                      :clearable="true" placeholder="上传时间"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="描述">
            <el-input class="input-item" v-model="formData.PaWorkDraft.workDetail" :disabled="true"
               placeholder="描述" type="textarea" :autosize="{ minRows: 1,maxRows:3}"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" @click="onUpdateClick()">
              修改
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */

/* eslint-disable-next-line */

/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaWorkDraftController, DictionaryController } from '@/api';

export default {
  name: 'EditWorkDraft',
  props: {
    id: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      showlvMin: false,
      showlvMax: false,
      showmoney: false,
      showLvD: false,
      labellvMin: '比例区间最低',
      labellvMax: '比例区间最高',
      labelmoney: '奖励金额',
      formData: {
        PaWorkDraft: {
          id: undefined,
          pid: undefined,
          tid: undefined,
          workBigTypeName: undefined,
          workTypeName: undefined,
          workTypeId: undefined,
          code: undefined,
          type: undefined,
          workName: undefined,
          workDetail: undefined,
          remark: undefined,
          deptPostId: undefined,
          deptPostName: undefined,
          deptPostNameT: undefined,
          deptPostIdT: undefined,
          enableFlag: 'Y',
          sort: 1,
          userName: undefined,
          score: 0,
          money: 0,
          lvD: 0,
          lvE: 0,
          lvF: 0,
          assessDetail: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          isDatasourceInit: false
        }
      },
      rules: {
        'PaWorkDraft.name': [{required: true, message: '请输入名称', trigger: 'blur'}],
        'PaWorkDraft.lvMin': [{required: true, message: '请输入区间最低', trigger: 'blur'}],
        'PaWorkDraft.lvMax': [{required: true, message: '请输入区间最高', trigger: 'blur'}],
        'PaWorkDraft.money': [{required: true, message: '请输入奖励金额', trigger: 'blur'}]
      },
      EditWorkDraft: {
        formFilter: {
        },
        formFilterCopy: {
        },
        type: {
          impl: new DropdownWidget(this.loadTypeDropdownList)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      },
      workpostList: {
        id: undefined,
        name: undefined,
        parentId: undefined
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 类型下拉数据获取函数
     */
    loadTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {pid: this.formData.PaWorkDraft.workTypeId};
        DictionaryController.dictSysWorkDraft(this, params).then(res => {
          resolve(res.getList());
          this.workpostList = res.getList();
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onTypeValueChange (value) {
      for (let i = 0; i < this.workpostList.length; i++) {
        if (this.workpostList[i].id === this.formData.PaWorkDraft.deptPostName) {
          this.formData.PaWorkDraft.score = this.workpostList[i].parentId;
          this.formData.PaWorkDraft.deptPostNameT = this.workpostList[i].name;
          this.formData.PaWorkDraft.deptPostIdT = this.workpostList[i].id;
        }
      }
    },

    /**
     * 启用选中值改变
     */
    onEnableFlagValueChange (value) {
    },
    /**
     * 更新编辑作品等级分值
     */
    refreshEditWorkDraft (reloadData = false) {
      this.loadPaWorkDraftData().then(res => {
        if (!this.EditWorkDraft.isInit) {
          // 初始化下拉数据
          this.EditWorkDraft.type.impl.onVisibleChange(true).catch(e => {});
        }
        this.EditWorkDraft.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onUpdateClick () {
      this.$refs.EditWorkDraft.validate((valid) => {
        if (!valid) return;
        let paWorkDraft = this.formData.PaWorkDraft;
        if (paWorkDraft.type === 'post') {

        }

        let params = {
          paWorkDraftDto: {
            id: this.id,
            assessDetail: this.formData.PaWorkDraft.assessDetail,
            deptPostId: this.formData.PaWorkDraft.deptPostIdT,
            score: this.formData.PaWorkDraft.score,
            deptPostName: this.formData.PaWorkDraft.deptPostNameT,
            status: 'completed',
            workName: this.formData.PaWorkDraft.workName,
            workBigTypeId: this.formData.PaWorkDraft.workBigTypeId,
            workBigTypeName: this.formData.PaWorkDraft.workBigTypeName,
            workTypeId: this.formData.PaWorkDraft.workTypeId,
            workTypeName: this.formData.PaWorkDraft.workTypeName,
            workDetail: this.formData.PaWorkDraft.workDetail,
            workUrl: this.formData.PaWorkDraft.workUrl,
            workImgUrl: this.formData.PaWorkDraft.workImgUrl,
            deptId: this.formData.PaWorkDraft.deptId,
            deptName: this.formData.PaWorkDraft.deptName,
            deptTid: this.formData.PaWorkDraft.deptTid,
            userId: this.formData.PaWorkDraft.userId,
            userName: this.formData.PaWorkDraft.userName,
            assessUserId: this.formData.PaWorkDraft.assessUserId,
            assessTime: this.formData.PaWorkDraft.assessTime,
            assessLv: this.formData.PaWorkDraft.assessLv,
            scoreDetail: this.formData.PaWorkDraft.scoreDetail,
            payrollId: this.formData.PaWorkDraft.payrollId,
            payrollLineId: this.formData.PaWorkDraft.payrollLineId
          }
        };

        this.$confirm('是否保存修改?').then(res => {
          PaWorkDraftController.update(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        }).catch(e => {});
      });
    },
    onResume () {
      this.refreshEditWorkDraft(true);
    },
    /**
     * 获取作品级别分值详细信息
     */
    loadPaWorkDraftData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.PaWorkDraft.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          PaWorkDraftController.view(this, params).then(res => {
            let PaWorkDraft = {...res.data, isDatasourceInit: true};
            if (PaWorkDraft !== null) {
              this.formData.PaWorkDraft = PaWorkDraft;
              this.formData.PaWorkDraft.deptPostNameT = PaWorkDraft.deptPostName;
              this.formData.PaWorkDraft.deptPostIdT = PaWorkDraft.deptPostId;
              resolve();
            }
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaWorkDraft: {
          id: undefined,
          pid: undefined,
          tid: undefined,
          workBigTypeName: undefined,
          workTypeName: undefined,
          workTypeId: undefined,
          code: undefined,
          type: undefined,
          workName: undefined,
          workDetail: undefined,
          remark: undefined,
          deptPostId: undefined,
          deptPostName: undefined,
          enableFlag: undefined,
          sort: undefined,
          userName: undefined,
          score: 0,
          money: 0,
          lvD: 0,
          lvE: 0,
          lvF: 0,
          assessDetail: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshEditWorkDraft();
    }
  },
  computed: {
    // 初始化组件数据所需输入参数
    initPaWorkDraftParamChange () {
      return {
        id: this.id
      }
    },
    // 监听输入参数变化，用于数据变化后重新获取数据，如果存在多个数据组件或者数据组件使用不同的输入参数的优化，请拆分这里的代码
    formInputParamChange () {
      return {
        id: this.id
      }
    }
  },
  watch: {
    // 初始化组件数据所需输入参数，如果有多个初始化数据源需要优化，请修改这里的代码，只重置和更新相应的数据源数据
    initPaWorkDraftParamChange: {
      handler (newValue) {
        this.resetFormData();
        this.refreshEditWorkDraft();
      },
      immediate: true
    },
    formInputParamChange: {
      handler (newValue) {
      },
      immediate: true
    }
  }
}
</script>
